import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useAuth } from "../context/API_Client";

const BusinessDropdown = ({ units, setUnits }) => {
  const [mainDropdownOpen, setMainDropdownOpen] = useState(false);
  const [unitsState, setUnitsState] = useState(units);
  const [firstDropdownValue, setFirstDropdownValue] = useState("");
  const [secondDropdownValue, setSecondDropdownValue] = useState("");
  const [firstDropdownOpen, setFirstDropdownOpen] = useState(false);
  const [secondDropdownOpen, setSecondDropdownOpen] = useState(false);
  const [unitsError, setUnitsError] = useState([]);
  const [businessUnits, setBusinessUnits] = useState([]);
  const [pointOfSale, setPointOfSale] = useState([]);

  const { getBusinessUnits, getAllVisualizationData } = useAuth();

  useEffect(() => {
    getBusinessUnits(
      function (data) {
        setBusinessUnits(data);
      },
      function (errorMsg) {
        console.log(errorMsg);
        setUnitsError(errorMsg);
      }
    );
  }, []);

  useEffect(() => {
    if (firstDropdownValue) {
      getAllVisualizationData(
        "entities/legal_entities",
        firstDropdownValue,
        function (data) {
          setPointOfSale(
            data.points.filter(
              (point) => point.legalEntity === firstDropdownValue
            )
          );
        },
        function (errorMsg) {
          console.log(errorMsg);
          setUnitsError(errorMsg);
        }
      );
    }
  }, [firstDropdownValue]);

  const DropDownMain = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    // position:'absolute',
    // right:' 0',
  };

  const DropDownTwo = {
    marginRight: "14px",
    backgroundColor: "#007bff",
  };

  const DropdownOne = {
    margin: "0px 10px 0px 10px",
    backgroundColor: "#007bff",
  };

  const handleFirstDropdownChange = (value) => {
    setFirstDropdownValue(value);
    console.log(firstDropdownValue);
    setUnits((prevUnits) => ({ ...prevUnits, legalEntityCode: value }));
  };

  const handleSecondDropdownChange = (value) => {
    setSecondDropdownValue(value);
    setUnits((prevUnits) => ({ ...prevUnits, clientPosId: value }));
  };

  return (
    <div style={DropDownMain}>
      <Dropdown
        isOpen={firstDropdownOpen}
        toggle={() => setFirstDropdownOpen(!firstDropdownOpen)}
      >
        <DropdownToggle style={DropdownOne} caret>
          {" "}
          {businessUnits?.find((option) => option.code === firstDropdownValue)
            ?.name || "->Business Unit<-"}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => {
              handleFirstDropdownChange(null);
              handleSecondDropdownChange(null);
            }}
          >
            {"->Business<-"}
          </DropdownItem>
          {businessUnits?.map((option, idx) => (
            <DropdownItem
              key={idx}
              onClick={() => handleFirstDropdownChange(option?.code)}
            >
              {option?.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>

      <Dropdown
        isOpen={secondDropdownOpen}
        toggle={() => setSecondDropdownOpen(!secondDropdownOpen)}
      >
        <DropdownToggle style={DropDownTwo} caret>
          {pointOfSale?.find(
            (option) => option.clientPosId === secondDropdownValue
          )?.clientPosId || "->Point of Sale<-"}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => handleSecondDropdownChange(null)}>
            {"->Point of Sale<-"}
          </DropdownItem>
          {firstDropdownValue &&
            pointOfSale.map((option, idx) => (
              <DropdownItem
                key={idx}
                onClick={() => handleSecondDropdownChange(option.clientPosId)}
              >
                {option.clientPosId}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default BusinessDropdown;
